import jq from 'jquery';
import _ from 'ext:lodash';
import Framework from 'framework';

const POST = 'POST';
const GET = 'GET';
const minimumPricedProductsPath = 'v1/product/minimum/price';
const timeout = 30000;

//Export Value
let contract = {};

function getBaseUrl() {
	return Framework.global.lt.api.omsUrl;
}

function getSubscriptionKey() {
	return Framework.global.lt.api.apimKey;
}

function omsServiceUrl(resourcePath) {
	return getBaseUrl() + (resourcePath ? resourcePath : '');
}

function headers() {
	return {
		'Ocp-Apim-Subscription-Key': getSubscriptionKey(),
		'Ocp-Apim-Trace': true,
		'Content-Type': 'application/json; charset=UTF-8'
	};
}

function ajaxCall(method, resourcePath) {
	return $.ajax({
		url: contract.getUrl(resourcePath),
		method: method,
		async: true,
		timeout: timeout,
		crossDomain: true,
		headers: contract.getHeaders(),
		dataType: 'json'
	});
}

const omsService = {
	getMinimumPricedProducts(){
		var callMethod = GET;
		return new Promise((resolve, reject)=> {
			contract.ajaxCaller(callMethod, minimumPricedProductsPath)
				.then(
					//Success
					(data, textStatus) => {
						resolve(data);
					},
					//Failure
					(jqXHR, textStatus, errorThrown) => {
						reject(errorThrown);
					});
		});
	}
};

contract = {
	api: omsService,
	ajaxCaller: ajaxCall,
	getHeaders: headers,
	getUrl: omsServiceUrl
};

export default contract;
